import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { darkTheme, dateZhCN, NConfigProvider, zhCN, NGlobalStyle } from "naive-ui";
import { ref, provide, onMounted, onUnmounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const themeOverrides = ref({
  common: {
    primaryColor: '#F59E0B',    // 黄色
    primaryColorHover: '#FBBF24',
    primaryColorPressed: '#D97706',
    primaryColorSuppl: '#F59E0B',
  }
});

// 统一调试模式：Ctrl+Shift+D 一键切换所有快捷显示（收益统计/高级设置/线路地址/卡牌真实模式）
const debugMode = ref(false);
provide('debugMode', debugMode);

function handleKeydown(e: KeyboardEvent) {
  if (e.ctrlKey && e.shiftKey && e.key === 'D') {
    e.preventDefault();
    debugMode.value = !debugMode.value;
    localStorage.setItem('kp_debugMode', debugMode.value ? '1' : '0');
  }
}

onMounted(() => {
  debugMode.value = localStorage.getItem('kp_debugMode') === '1';
  window.addEventListener('keydown', handleKeydown);
});
onUnmounted(() => window.removeEventListener('keydown', handleKeydown));

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    class: "app-content",
    theme: _unref(darkTheme),
    locale: _unref(zhCN),
    "date-locale": _unref(dateZhCN),
    "theme-overrides": themeOverrides.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NGlobalStyle)),
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["theme", "locale", "date-locale", "theme-overrides"]))
}
}

})